import React, {forwardRef} from "react";
import {ADivider} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import DrawerContent from "../../components/DrawerContent/DrawerContent";
import css from "./DrawerFooter.module.scss";

/**
 * The area displayed at the bottom of the drawer.
 */
const DrawerFooter = forwardRef(({children, className, ...rest}, ref) => {
  return (
    <div
      {...rest}
      ref={ref}
      className={classNames(css.drawerFooterContent, className)}>
      <ADivider />
      <DrawerContent hideDivider className={css.drawerFooterAction}>
        {children}
      </DrawerContent>
    </div>
  );
});

export default DrawerFooter;
